import { render, staticRenderFns } from "./VSpinner.vue?vue&type=template&id=ab60736a&functional=true&"
var script = {}
import style0 from "./VSpinner.vue?vue&type=style&index=0&id=ab60736a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports